import { Button, Container, Stack } from "@mantine/core";
import FileUploaderSimple from "./FileUploaderSimple";
import { useState } from "react";
import { uploadFile } from "../api";
import { useLocation } from "wouter";
import { useTranslation } from "react-i18next";

function UploadPage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [, setLocation] = useLocation();
  const { t } = useTranslation("imports");

  return (
    <Container size="sm">
      <Stack>
        <FileUploaderSimple onFileSelected={setSelectedFile} />

        <Button
          loading={isUploading}
          onClick={() => {
            setIsUploading(true);
            console.log("File selected:", selectedFile);
            uploadFile(selectedFile)
              .then(() => {
                setLocation("/imports");
              })
              .finally(() => {
                setIsUploading(false);
              });
          }}
          disabled={!selectedFile}
        >
          {t("upload.submit")}
        </Button>
      </Stack>
    </Container>
  );
}

export default UploadPage;
